<template>
  <div class="image">
    <img :src="image" :alt="imageAlt" />
    <PRBadge v-if="showPr" class="pr" />
  </div>
  <div :class="{ 'wide-container': wide }">
    <p :class="[headingClass, 'clamp']">{{ title }}</p>
    <p v-if="description" class="clamp">
      {{ description }}
    </p>
    <div class="meta">
      <p v-if="category" class="recommend_cat">
        {{ category }}
      </p>
      <p v-if="date" class="date">{{ date }}</p>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import PRBadge from '../elements/PRBadge.vue'

export default defineComponent({
  name: 'MagazineCardContent',

  components: {
    PRBadge
  },

  props: {
    wide: Boolean,
    image: {
      type: String,
      default: require('@/assets/images/common/noimg.jpg')
    },
    imageAlt: {
      type: String,
      default: ''
    },
    title: String,
    date: String,
    category: {
      type: String,
      default: ''
    },
    description: String,
    showPr: Boolean
  },

  setup(props) {
    const headingClass = {
      magazineCard_heading: !props.wide,
      magazineCard_heading_wide: props.wide
    }

    return {
      headingClass
    }
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
.image {
  position: relative;
}

.pr {
  position: absolute;
  left: 0;
  top: 0;
}

img {
  width: 100%;
}

.magazineCard_heading {
  margin-top: 10px;
  font-weight: 500;
  font-size: 20px;
  letter-spacing: 0.03em;
  line-height: 1.55;
}

.magazineCard_heading_wide {
  line-height: 1.2;
  letter-spacing: 0.03em;
}

.recommend_cat {
  display: inline-block;
  font-size: 1rem;
  font-weight: 500;
  background-color: #fffccb;
  padding: 4px;
  line-height: 1;
}
.clamp {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.wide-container {
  margin-left: 20px;
}
.meta {
  margin-top: 4px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.date {
  font-size: 1.2rem;
  color: #666;
}
</style>
